import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { useOnScreen } from "hooks/useOnScreen"

const StyledTextarea = styled.div`
  ${(props) =>
    props.theme.utils.getBoxModel(
      props.theme.input[props.size].padding,
      null,
      props.theme.input[props.size].margin
    )};

  textarea {
    line-height: ${(props) => `${props.theme.input[props.size].lineHeight}rem`};
    width: 100%;
    border: none;
  }

  ${(props) =>
    props.renderAsFormField &&
    `
      padding-top: ${`${(props.theme.input[props.size].padding[0] * 2).toFixed(
        2
      )}rem`};
      padding-bottom: ${`${(
        props.theme.input[props.size].padding[0] * 0.75
      ).toFixed(2)}rem`};

      textarea {
        border: none;
        padding: 0;
        margin: 0;
      }
    `}
`

const Textarea = React.forwardRef(
  (
    { size, renderAsFormField, value, disableTabWhileInvisible, ...props },
    ref
  ) => {
    const isOnScreen = useOnScreen(ref)
    return (
      <StyledTextarea renderAsFormField={renderAsFormField} size={size}>
        <textarea
          value={value}
          ref={ref}
          tabIndex={!isOnScreen && disableTabWhileInvisible ? "-1" : ""}
          {...props}
        />
      </StyledTextarea>
    )
  }
)

export default Textarea

Textarea.defaultProps = {
  size: "md",
  renderAsFormField: false,
  value: "",
}
Textarea.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  renderAsFormField: PropTypes.bool,
  value: PropTypes.node,
}
